module.exports = __webpack_public_path__ + "static/media/alfa-romeo-go-drive.19c30d4d.jpg";